/* NAD+ Perfected landing page (hpn-nadp-*): smooth in-page scrolling + timeline draw animation. */
(function () {
  'use strict';

  if (window.__hpnNadpReady) return;
  window.__hpnNadpReady = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function easeInOut(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function easeOut(t) {
    return 1 - Math.pow(1 - t, 2);
  }

  function tween(duration, onFrame, onDone) {
    var start = null;
    function frame(now) {
      if (start === null) start = now;
      var t = Math.min(1, (now - start) / duration);
      onFrame(t);
      if (t < 1) {
        window.requestAnimationFrame(frame);
      } else if (onDone) {
        onDone();
      }
    }
    window.requestAnimationFrame(frame);
  }

  /* ---------- Smooth scrolling for in-page links (e.g. #mgn-nad3-main-shop) ---------- */

  function scrollToTarget(target) {
    var startY = window.pageYOffset;
    var endY = target.getBoundingClientRect().top + startY - 12;
    var distance = endY - startY;
    if (reduceMotion || Math.abs(distance) < 4) {
      window.scrollTo(0, endY);
      return;
    }
    var duration = Math.min(1200, Math.max(500, Math.abs(distance) * 0.35));
    tween(duration, function (t) {
      window.scrollTo(0, startY + distance * easeInOut(t));
    });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest && e.target.closest('a[href*="#"]');
    if (!link) return;
    var url;
    try {
      url = new URL(link.getAttribute('href'), window.location.href);
    } catch (err) {
      return;
    }
    if (url.pathname !== window.location.pathname || !url.hash || url.hash.length < 2) return;
    var target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!target) return;
    e.preventDefault();
    scrollToTarget(target);
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', url.hash);
    }
  });

  /* ---------- Timeline draw animation ---------- */

  var desktopQuery = window.matchMedia('(min-width: 900px)');

  function lengthAtX(path, x, total) {
    var lo = 0;
    var hi = total;
    for (var i = 0; i < 24; i++) {
      var mid = (lo + hi) / 2;
      if (path.getPointAtLength(mid).x < x) lo = mid;
      else hi = mid;
    }
    return (lo + hi) / 2;
  }

  function finish(root) {
    root.classList.add('is-drawn');
    root.querySelectorAll('[data-item], [data-dot], [data-tick]').forEach(function (el) {
      el.classList.add('is-on');
    });
    root.querySelectorAll('[data-curve]').forEach(function (p) {
      p.style.strokeDashoffset = '0';
    });
    root.style.setProperty('--nadp-vp', '1');
  }

  function runDesktop(root, seconds) {
    var curves = Array.prototype.slice.call(root.querySelectorAll('[data-curve]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    var ticks = Array.prototype.slice.call(root.querySelectorAll('[data-tick]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-item]'));
    if (!curves.length || !curves[0].getTotalLength) {
      finish(root);
      return;
    }

    var total = curves[0].getTotalLength();
    curves.forEach(function (p) {
      p.style.strokeDasharray = total + ' ' + total;
      p.style.strokeDashoffset = String(total);
    });

    var stops = dots.map(function (dot) {
      return lengthAtX(curves[0], Number(dot.getAttribute('data-x')), total);
    });
    stops.push(total);

    var revealed = 0;

    function reveal(i) {
      if (dots[i]) dots[i].classList.add('is-on');
      if (ticks[i]) ticks[i].classList.add('is-on');
      if (items[i]) items[i].classList.add('is-on');
    }

    // One continuous stroke: the line never pauses; each dot and label
    // appears the moment the line passes it.
    tween(seconds * 1000, function (t) {
      var len = total * easeOut(t);
      curves.forEach(function (p) {
        p.style.strokeDashoffset = String(total - len);
      });
      while (revealed < stops.length - 1 && len >= stops[revealed] - 1) {
        reveal(revealed);
        revealed += 1;
      }
    }, function () {
      finish(root);
    });
  }

  function runMobile(root, seconds) {
    var list = root.querySelector('[data-items]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-item]'));
    if (!list) {
      finish(root);
      return;
    }
    var height = list.getBoundingClientRect().height || 1;
    var marks = items.map(function (item) {
      return Math.min(1, (item.offsetTop + 15) / height);
    });

    tween(seconds * 1000, function (t) {
      var p = easeOut(t);
      root.style.setProperty('--nadp-vp', String(p));
      marks.forEach(function (m, i) {
        if (p >= m - 0.01) items[i].classList.add('is-on');
      });
    }, function () {
      finish(root);
    });
  }

  function initTimeline(root) {
    if (!root || root.__nadpTimeline) return;
    root.__nadpTimeline = true;

    if (!root.hasAttribute('data-animate') || reduceMotion || !('IntersectionObserver' in window)) {
      finish(root);
      return;
    }

    var desktopDrawn = root.classList.contains('hpn-nadp-timeline--drawn');
    var seconds = parseFloat(getComputedStyle(root).getPropertyValue('--nadp-speed')) || 3;

    // Arm: hide what will animate in (CSS keys off this class, so no-JS visitors see everything)
    root.classList.add('is-armed');
    if (desktopQuery.matches && desktopDrawn) {
      var curves = root.querySelectorAll('[data-curve]');
      curves.forEach(function (p) {
        if (!p.getTotalLength) return;
        var total = p.getTotalLength();
        p.style.strokeDasharray = total + ' ' + total;
        p.style.strokeDashoffset = String(total);
      });
    } else {
      root.style.setProperty('--nadp-vp', '0');
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        if (desktopQuery.matches) {
          if (desktopDrawn) runDesktop(root, seconds);
          else finish(root);
        } else {
          runMobile(root, seconds);
        }
      });
    }, { threshold: 0.35 });

    observer.observe(root);

    // If the layout switches between phone and desktop mid-way, just show the finished graph
    var onChange = function () {
      observer.disconnect();
      finish(root);
    };
    if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', onChange);
    else if (desktopQuery.addListener) desktopQuery.addListener(onChange);
  }

  function boot() {
    document.querySelectorAll('[data-nadp-timeline]').forEach(initTimeline);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-nadp-timeline]');
    if (root) {
      root.__nadpTimeline = false;
      initTimeline(root);
    }
  });
})();
